module.exports = __webpack_public_path__ + "img/VIP-11.aa3bcb74.png";